import {Component, inject} from '@angular/core';
import {LogoSpinner} from '@ui/SpinnersModule/components/logo-spinner/logo-spinner';
import {SpinnerSimple} from '@ui/SpinnersModule/components/spinner-simple/spinner-simple';
import {SpinnerPort} from '@shared/application/ports/spinner/spinner.port';

@Component({
  selector: 'app-spinner-global',
  imports: [
    SpinnerSimple
  ],
  templateUrl: './spinner-global.html',
  styles: `
    .overlay {
      position: fixed;
      inset: 0;
      z-index: 9999;

      display: flex;
      justify-content: center;
      align-items: center;
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);

      animation: fadeIn 180ms ease-out;
    }

    .spinner-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 14px;

      padding: 28px 32px;
      border-radius: 16px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12),
      0 4px 12px rgba(0, 0, 0, 0.08);

      animation: scaleIn 220ms ease-out;
    }

    .spinner-ring {
      border-radius: 50%;
      border: 4px solid rgba(0, 0, 0, 0.08);
      border-top-color: #3b82f6; /* azul moderno */

      animation: spin 0.9s linear infinite;
    }

    .spinner-text {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.2px;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes scaleIn {
      from {
        transform: scale(0.92);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }

    .logo-spinner {
      width: 80px;
      height: auto;

      animation: float 3s ease-in-out infinite;
    }

    .logo-spinner .part {
      stroke: var(--color-primary);
      stroke-width: 3;
      stroke-dasharray: 400;
      stroke-dashoffset: 400;
      animation: draw 1.2s ease-out forwards;
    }

    @keyframes draw {
      to {
        stroke-dashoffset: 0;
      }
    }

    @keyframes float {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-6px);
      }
    }

    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.75;
      }
    }

    .logo-spinner .main {
      animation-delay: 0ms;
    }

    .logo-spinner .accent {
      animation-delay: 120ms;
    }

    .logo-spinner .detail {
      animation-delay: 240ms;
    }

  `,
})
export class SpinnerGlobal {

  public readonly spinnerPort: SpinnerPort = inject(SpinnerPort);

  constructor() {
  }

}
